export class StringStorage {
  constructor(private readonly key: string) {}

  getValue = (): string | null => {
    return localStorage.getItem(this.key);
  };

  setValue = (token: string): void => {
    localStorage.setItem(this.key, token);
  };

  clearValue = (): void => {
    localStorage.removeItem(this.key);
  };
}
